import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

const DocumentPage = () => {
  const { slug } = useParams();
  const [document, setDocument] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    const fetchDocument = async () => {
      try {
        const res = await axios.get(`${API}/documents/${slug}`);
        setDocument(res.data);
      } catch (err) {
        setError(true);
      } finally {
        setLoading(false);
      }
    };
    fetchDocument();
  }, [slug]);

  if (loading) {
    return (
      <div className="min-h-screen bg-[#050505] flex items-center justify-center">
        <div className="spinner"></div>
      </div>
    );
  }

  if (error || !document) {
    return (
      <div className="min-h-screen bg-[#050505] flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-white mb-4">Dokument nie znaleziony</h1>
          <Link to="/" className="btn-primary">Wróć na stronę główną</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-[#050505] min-h-screen">
      <Navbar />
      <main className="section-padding pt-32">
        <div className="container-custom max-w-3xl">
          <h1 className="text-4xl font-bold text-white mb-8" data-testid="document-title">{document.title}</h1>
          <div className="prose prose-invert max-w-none text-[#9CA3AF]" data-testid="document-content">
            {document.content.split('\n').map((paragraph, i) => (
              <p key={i} className="mb-4">{paragraph}</p>
            ))}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default DocumentPage;